import {FC} from 'react';
import {CircularProgress} from '@mui/material';
import {FormattedMessage} from 'react-intl';
import {chargersApi} from 'src/api';

interface CompanyChargerCountProps {
    companyId: number;
    locationId: number;
    businessId: number;
}

export const CompanyChargerCount: FC<CompanyChargerCountProps> = ({companyId, locationId, businessId}) => {
    const {data, isLoading} = chargersApi.useGetChargersQuery({
        data: {
            businessId,
            companyId,
            locationId,
        },
        params: {
            size: 1,
            page: 0,
        },
    });

    if (isLoading) {
        return <CircularProgress size={14}/>;
    }

    const count = data?.page?.totalElements ?? 0;

    return (
        <span>
            <FormattedMessage id="chargePointsCount" values={{count}}/>
        </span>
    );
};